import _styled, { default as _styled2 } from "styled-components";
const _excluded = ["id", "name", "url", "highlighted", "iconUrl", "hasDivider"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import * as analytics from '@adsk/acs-web-analytics';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { HomeIcon } from '@adsk/alloy-react-icon';
import { MenuList, MenuItem } from '@adsk/alloy-react-menu';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { ANALYTICS_TYPES } from '../helpers/analytics';
import getAnchorRel from '../helpers/getAnchorRel';
import getAnchorTarget from '../helpers/getAnchorTarget';
import { productsListShape } from '../helpers/propTypes';
// TODO - can be removed when account entitlement is available in V2
// TODO - verify it works as expected
const getProductIconV1 = product => {
  var _product$renderIcon;
  return product === null || product === void 0 ? void 0 : (_product$renderIcon = product.renderIcon) === null || _product$renderIcon === void 0 ? void 0 : _product$renderIcon.call(product, {
    size: 24
  });
};
const parser = (products, selectedId) => (products === null || products === void 0 ? void 0 : products.map(product => _objectSpread(_objectSpread({}, product), {}, {
  id: product.key,
  url: product.defaultUrl,
  highlighted: product.key === selectedId
}))) || [];
const MY_HOME_MENU_ITEM_ID = 'myHome';
const MenuItemText = styled.div.withConfig({
  displayName: "ProductPicker__MenuItemText",
  componentId: "sc-1o47157-0"
})(_objectSpread(_objectSpread(_objectSpread({}, theme.typography.bodyMedium), theme.typography.ellipsis), {}, {
  flex: 1,
  paddingLeft: 10,
  textAlign: 'left'
}));
const MenuItemWrapper = styled.div.withConfig({
  displayName: "ProductPicker__MenuItemWrapper",
  componentId: "sc-1o47157-1"
})({
  borderBottom: "1px solid ".concat(theme.colors.charcoal200)
});
const ProductPicker = _ref => {
  let {
    className,
    style,
    products,
    selectedId,
    onClose,
    onProductClick,
    renderCustomHeader = () => null
  } = _ref;
  const {
    value: showUserHomeTab
  } = useAlloyFeatureFlag('show-user-home-tab');
  const onProductClickWithAnalytic = useCallback(id => {
    analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_PROJECTPICKER_PRODUCT_CLICK, {
      product_id: id,
      prev_product_id: selectedId
    });
  }, [selectedId]);
  const getMenuItemProps = _ref2 => {
    let {
      id,
      url
    } = _ref2;
    return {
      as: onProductClick ? 'button' : 'a',
      'data-testid': "ProductPicker__product-".concat(id),
      href: url,
      target: url && getAnchorTarget(url),
      rel: getAnchorRel(url),
      nested: false,
      showSelection: false,
      onClick: event => {
        onProductClick === null || onProductClick === void 0 ? void 0 : onProductClick({
          id,
          url
        }, event);
        onProductClickWithAnalytic(id);
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      width: 300
    }, style]
  }, /*#__PURE__*/React.createElement(MenuList, null, showUserHomeTab && /*#__PURE__*/React.createElement(MenuItemWrapper, null, /*#__PURE__*/React.createElement(MenuItem, _extends({}, getMenuItemProps({
    id: MY_HOME_MENU_ITEM_ID,
    url: "".concat(getAccHostname(), "/home")
  }), {
    key: MY_HOME_MENU_ITEM_ID,
    highlighted: MY_HOME_MENU_ITEM_ID === selectedId,
    style: {
      marginBottom: '8px'
    }
  }), /*#__PURE__*/React.createElement(HomeIcon, {
    size: 24
  }), /*#__PURE__*/React.createElement(MenuItemText, null, "My Home"))), renderCustomHeader(), parser(products, selectedId).map(_ref3 => {
    let {
        id,
        name,
        url,
        highlighted,
        iconUrl,
        hasDivider
      } = _ref3,
      rest = _objectWithoutProperties(_ref3, _excluded);
    return /*#__PURE__*/React.createElement(MenuItem, _extends({}, getMenuItemProps({
      id,
      url
    }), {
      key: id,
      highlighted: highlighted,
      style: {
        borderTop: hasDivider ? "1px solid ".concat(theme.colors.charcoal200) : 'none',
        height: 40,
        borderRadius: 0
      }
    }), iconUrl ? /*#__PURE__*/React.createElement(_StyledSpan, {
      $_css2: [{
        maskImage: "url(".concat(iconUrl, ")"),
        backgroundColor: highlighted ? theme.colors.white : theme.colors.charcoal900,
        width: 24,
        height: 24
      }]
    }) : getProductIconV1(rest), /*#__PURE__*/React.createElement(MenuItemText, null, name));
  })));
};
ProductPicker.displayName = 'ProductPicker';
ProductPicker.defaultProps = {
  renderCustomHeader: () => null
};
ProductPicker.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Products list */
  products: productsListShape,
  /** Selected product ID */
  selectedId: PropTypes.string,
  /** menu close handler */
  onClose: PropTypes.func,
  /** Custom product click handler, unsafe */
  onProductClick: PropTypes.func,
  /** render custom header */
  renderCustomHeader: PropTypes.func
};
export default ProductPicker;
var _StyledDiv = styled("div").withConfig({
  displayName: "ProductPicker___StyledDiv",
  componentId: "sc-1o47157-2"
})(["", ""], p => p.$_css);
var _StyledSpan = styled("span").withConfig({
  displayName: "ProductPicker___StyledSpan",
  componentId: "sc-1o47157-3"
})(["", ""], p => p.$_css2);
//# sourceMappingURL=ProductPicker.js.map